import { render } from "./SearchInput.vue?vue&type=template&id=2c96b665&scoped=true&ts=true"
import script from "./SearchInput.vue?vue&type=script&lang=ts"
export * from "./SearchInput.vue?vue&type=script&lang=ts"

import "./SearchInput.vue?vue&type=style&index=0&id=2c96b665&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c96b665"]])

export default __exports__